<!--suppress HtmlUnknownTag, HtmlUnknownAttribute, CssUnusedSymbol -->
<template>
    <div style="display: flex;justify-content: center">
        <div style="width: 1400px;position:relative; ">
            <!-- <el-link style="position: absolute;right: 0;top: 10px" @click="visible=true">我要发布</el-link> -->
            <el-button style="float: left;position: relative;left: 100%;border-radius: 0 0 50px;color: #fff; background-color: #7d859d" @click="visible=true">我要发布</el-button>
            <el-dialog :visible.sync="visible" width="40%" :close-on-click-modal="false">
                <el-form label-width="150px" label-position="left" :model="trend"
                         style="padding: 100px;">
                    <el-form-item label="文本内容" style="margin-right: 10px !important;">
                        <el-input v-model="trend.content" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="图片" style="margin-right: 10px !important;">
                        <MultiImgUploader v-model="trend.imgs"></MultiImgUploader>
                    </el-form-item>
                    <el-form-item label="操作">
                        <el-button type="primary" @click="insertTrend">发布</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
            <div class="trend-item" v-for="(b,i) in trends" :key="i" style="position: relative;margin-top: 50px">
                <!--用户头像-->
                <div style="  width: 100px;display: flex;flex-direction: column;align-items: center">
                    <img ondragstart="return false" :src=" $store.state.backendHost+b.user.img.split(',')[0]" alt=""
                         style="height: 100px;width: 100px;border-radius: 50px;margin-bottom: 20px">
                    <!--                    <el-link type="primary" @click="$chatWithUser(b.user)">聊天</el-link>-->
                </div>

                <div style="margin-left: 20px;flex: 1">
                    <!--用户名 时间-->
                    <div style="display: flex;height: 100px;flex-direction: column;justify-content: space-between">
                        <div style="font-size: 2rem;color: #3e3e3e">{{ b.user.name }}</div>
                        <div style="font-size: 1rem;color:#3e3e3e">{{ b.createTime }}</div>
                    </div>
                    <hr>
                    <!--博客文本-->
                    <div style="font-size: 2rem;line-height: 4rem">
                        {{ b.content }}
                    </div>
                    <!--博客图片-->
                    <div :style="{gridTemplateColumns:`repeat(${cols},1fr)`} " class="list-container" v-if="b.imgs">
                        <div class="box"
                             :style="{gridColumn: i%cols+1,gridRow: Math.ceil((i+1)/cols)}"
                             v-for="(item,i) in b.imgs.split(',')" :key="i">
                            <div style="width: 200px;height: 200px;text-align: center;overflow: hidden;">
                                <img :src="$store.state.backendHost + item" alt="" style="height: 100%"
                                     ondragstart="return false">
                            </div>

                        </div>
                    </div>

                    <!--                    <div style="display: flex;flex-wrap: wrap;justify-content: start">-->
                    <!--                        -->
                    <!--                        <div v-for="(o,i) in b.imgs.split(',')" :key="i">-->
                    <!--                            <img ondragstart="return false" v-if="o.length!==0" :src="$store.state.backendHost + o"-->
                    <!--                                 style="height: 500px;width: 500px;border-radius: 30px" alt=""-->
                    <!--                                 :class="i%2===1?'first-img':'not-first-img'">-->
                    <!--                        </div>-->
                    <!--                        -->
                    <!--                    </div>-->

                    <!--评论列表-->
                    <div style="display: flex;flex-direction: column;margin-top: 10px">
                        <div v-for="(o,i) in b.comments"
                             style="height: 50px;display: flex;flex-direction: row;;margin: 15px 0;position: relative"
                             :key="i">
                            <!--                            <el-link style="position: absolute;right: 0" type="primary" @click="$chatWithUser(o.user)">-->
                            <!--                                聊天-->
                            <!--                            </el-link>-->
                            <div style="flex-grow: 1;">
                                <img ondragstart="return false"
                                     :src=" $store.state.backendHost+o.user.img.split(',')[0]" alt=""
                                     style="height: 50px;border-radius: 50px">
                            </div>
                            <div style="flex-grow: 50;margin-left: 10px">
                                <div style="display: flex;height: 50px;flex-direction: column;justify-content: space-between">
                                    <div><span style="color: #3e3e3e;font-size: 1rem;font-weight: bolder">{{
                                            o.user.name
                                        }}: </span><span style=";font-size: 1.3rem">{{ o.content }}</span>
                                    </div>
                                    <div style="font-size: 1rem;color: #3e3e3e">{{ o.createTime.slice(0, 16) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--发表评论-->
                    <div style="display: flex;flex-direction: row;margin: 10px 0">
                        <el-input v-model="b.comment.content"></el-input>
                        <el-button type="primary" @click="insertComment(b)">评论</el-button>
                    </div>
                </div>

            </div>

        </div>
    </div>

</template>
<script>
import MultiImgUploader from "@/components/MultiImgUploader.vue";

export default {
    name: "TrendManage",
    components: {MultiImgUploader},
    watch: {},
    data() {
        return {
            role: this.$store.state.loginUser.role,
            trendSelect: {
                trend: {
                    content: '',
                    userId: 0,
                    createTime: '',
                },
                pageVo: {
                    pageSize: 5,
                    pageIndex: 1,
                    total: 0
                }
            },
            imgs: [],
            trend: {
                id: null,
                content: '',
                imgs: '',
                userId: 0,
                createTime: '',
            },
            trends: [],
            selectedTrend: {},
            trendDialogMode: 1,
            trendDialogVisible: false,
            visible: false,
            cols: 3,
            //全量查询
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return "";
            if (value.length > 10) {
                return value.slice(0, 10) + "...";
            }
            return value;
        }
    },
    methods: {

        deleteTrend(trend, index) {
            if (this.$store.state.loginUser.id !== trend.userId) {
                this.$message.warning('您无权删除别人的动态');
                return
            }
            this.$axios({
                url: "/trendComment/delete?id=" + trend.id,
                method: 'get',
                headers: {'content-type': 'application/json'},
            }).then((r) => {
                if (r.data === 1) {
                    this.trends.splice(index, 1)
                    this.$message.success('动态删除成功');
                } else {
                    this.$message.error('动态删除失败');
                }
            })
        },

        insertComment(trend) {
            trend.comment.userId = this.$store.state.loginUser.id
            trend.comment.type = "留言"
            if (trend.comment.content === null) {
                this.$message.warning('请输入内容');
                return
            }
            let data = JSON.stringify(trend.comment)
            this.$axios({
                url: "/trendComment/insert",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data > 0) {
                    trend.comment.id = r.data
                    trend.comment.user = this.$store.state.loginUser
                    trend.comment.createTime = this.timeF(new Date())
                    trend.comments.push(trend.comment)
                    this.$message.success('评论成功');
                } else {
                    this.$message.error('失败');
                }
            })
        },

        timeF(date) {
            function padZero(num) {
                return num < 10 ? '0' + num : num;
            }

            let year = date.getFullYear();
            let month = padZero(date.getMonth() + 1);
            let day = padZero(date.getDate());
            let hours = padZero(date.getHours());
            let minutes = padZero(date.getMinutes());
            let seconds = padZero(date.getSeconds());
            return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
        },
        reset() {
            this.trendSelect.trend = {}
            this.getTrend()
        },
        //crud
        insertTrend() {
            this.trend.userId = this.$store.state.loginUser.id
            if (this.trend.content === null || this.trend.content.length === 0) {
                this.$message.warning('请输入内容');
                return
            }
            this.trend.id = null
            let data = JSON.stringify(this.trend)
            this.$axios({
                url: "/trend/insert",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data > 0) {
                    this.getTrend()
                    this.$message.success('发布成功');
                    this.visible = false
                } else {
                    this.$message.error('发布失败');
                }
            })
        },
        dup(o) {
            this.trend = o
            this.insertTrend()
        },
        modifyTrend() {
            let data = JSON.stringify(this.trend)
            this.$axios({
                url: "/trend/update",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data === 1) {
                    this.$message.success('用人需求修改成功');
                } else {
                    this.$message.error('用人需求修改失败');
                }
            })
        },
        getTrend() {
            // this.trendSelect.trend.userId = this.$store.state.loginUser.id
            let data = JSON.stringify(this.trendSelect)
            this.$axios({
                url: "/trend/select",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                this.trends = r.data.trends
            })
        },
        //crud public
        handleTrendDialog(mode, trend) {
            this.trendDialogMode = mode
            this.trendDialogVisible = true
            if (mode === 1) {
                this.trend = {
                    id: null,
                    userId: 0,
                    createTime: '',
                    remark: '',
                    img: '',
                    status: 0,
                }
            }
            if (mode === 2) {
                this.trend = trend
            }
        },
        handleTrendDialogConfirm() {
            if (this.trendDialogMode === 1) this.insertTrend()
            if (this.trendDialogMode === 2) this.modifyTrend()
            this.trendDialogVisible = false
        },
        submitUpload() {
            this.$refs.upload.submit()
        },
        uploadSucc(response, file) {
            this.imgs.push(response)
        },
        //common
        tableClass({row, rowIndex}) {
            return rowIndex % 2 === 1 ? "even-row" : "no-even-row"
        },
        //全量查询
    },
    mounted() {
        this.reset()
        //全量查询
    },
}
</script>
<style scoped>
.el-radio-button__inner {
    border: 0 !important;
    border-radius: 0 !important;
    /*background-color: transparent !important;*/
}

/deep/ .el-textarea__inner {
    font-family: 'system-ui';
    border-radius: 0 !important;
}

/deep/ .el-input__inner {
    border-radius: 0 !important;
}

/* /deep/ .el-button {
    border-radius: 0 !important;
} */

.trend-item:hover {
    /*animation: back-ground-breath 5s infinite backwards;*/

}

.trend-item {
    display: flex;
    flex-direction: row;
    margin: 20px 0;;
    padding: 20px;;
    box-shadow: 0 0 20px #00000025;
    transition-property: box-shadow;
    transition-duration: 0.3s;
}

.first-img {
    margin-left: 0;
}

@keyframes back-ground-breath {
    0% {
        box-shadow: 0 0 20px #41b883;
    }
    20% {
        box-shadow: 0 0 20px yellow;
    }
    40% {
        box-shadow: 0 0 20px orangered;
    }
    60% {
        box-shadow: 0 0 20px deeppink;
    }
    80% {
        box-shadow: 0 0 20px orangered;
    }
    100% {
        box-shadow: 0 0 20px #41b883;
    }
}

/*/deep/ .el-textarea__inner:hover {*/
/*    color: aliceblue !important;*/
/*}*/

.not-first-img {
    margin-left: 10px;
}

.list-container {
    display: grid;
    width: 800px;
    gap: 20px;
    padding: 20px 0;
}

</style>
